export default "__VITE_ASSET__fdfedd38__"